<template>
  <div class="cookie-confirmation">
    <div class="cookie-icon" />
    <div class="cookie-text">
      <span class="cookie-use"
        >Оставаясь, вы
        <a
          class="cookie-link"
          target="_blank"
          href="https://static.price.ru/docs/PriceExpressAggreement1.pdf"
          >соглашаетесь</a
        >
        с
        <a
          class="cookie-link"
          target="_blank"
          href="https://static.price.ru/docs/PriceExpressPersonalDataPolicy.pdf"
          >политикой</a
        ></span
      >
    </div>
    <div class="btn-wrapper">
      <ui-ui-button
        id="cookie-confirm"
        type="secondary"
        size="medium"
        :resize="true"
        :font-weight="400"
        @click="confirm"
      >
        Принять
      </ui-ui-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import { maxAge } from '~/common/const';
import { useMediaQueryStore } from '@/stores/mediaQuery';

const { $ymAnyEvent } = useNuxtApp();
const globalStore = useGlobalStore();
const mediaStore = useMediaQueryStore();
const isTablet = computed(() => mediaStore.isTablet);
const isMobile = computed(() => mediaStore.isMobile);

onMounted(() => {
  if (isMobile.value || isTablet.value) {
    setTimeout(() => {
      globalStore.setIsCookieConfirm(true);
    }, 5000);
  }
});

const confirm = () => {
  if (!import.meta.env.SSR) {
    $ymAnyEvent('reachGoal', 'Accept_cookie');
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    const cookieConfirm = useCookie<string | undefined>('cookie-confirm', {
      domain,
      default: () => undefined,
      maxAge,
    });
    cookieConfirm.value = new Date().toLocaleDateString('ru');
  }
  globalStore.setIsCookieConfirm(true);
};
</script>
<style scoped lang="scss">
.cookie-confirmation {
  position: fixed;
  z-index: 76;
  left: calc(50% - 156px);
  bottom: 50px;
  display: flex;
  align-items: center;
  width: 312px;
  height: 48px;
  padding: 8px 8px 8px 12px;
  border-radius: 6px;
  background: $achromatic-black;
  @include md-block() {
    left: calc(50% - 216px);
    padding: 8px 8px 8px 12px;
    width: 432px;
    .btn-wrapper {
      min-width: 110px;
    }
  }
  @include xl-block() {
    .btn-wrapper {
      min-width: 126px;
    }
    z-index: 80;
    bottom: 100px;
    left: calc(50% - 247px);
    padding: 8px 8px 8px 12px;
    width: 494px;
    height: 52px;
  }
}

.cookie-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background: url('/static/images/cookie.png') center / cover no-repeat;
}

.cookie-text {
  display: flex;
  flex-direction: column;
  margin-right: 24px;
  color: $white;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  @include md-block() {
    flex-direction: row;
  }
  @include xl-block() {
    font-size: 14px;
    line-height: 20px;
  }

  .cookie-use {
    @include md-block() {
      margin-right: 8px;
    }
  }
}

.cookie-link {
  text-decoration-line: underline;
}

#cookie-confirm {
  margin-left: auto;
  height: 32px;
  @include xl-block() {
    width: 126px;
    height: 36px;
  }
}
</style>
